<template>
    <div class="panel panel-default">

        <div class="panel-heading">
          <div class="instructions" v-if="userIsAdmin">
            <span class="badge">Step 1</span> Select a Group &nbsp;
            <span class="badge">Step 2</span> Select at least 1 Course &nbsp;
            <span class="badge">Step 3</span> Select at least 1 Cohort &nbsp;
          </div>
          <div class="instructions" v-else>
            <span class="badge">Step 1</span> Select at least 1 Course &nbsp;
            <span class="badge">Step 2</span> Select at least 1 Cohort &nbsp;
          </div>
          <div class="pull-right">
            <button id="beta-tag" class="btn btn-warning btn-xs" data-toggle="tooltip" data-placement="bottom" title="Possible issues with a chart can be resolved by clicking the refresh button on the chart itself.">
              <i class="fas fa-info-circle"></i>
              beta feature
            </button>
          </div>
        </div>

        <div class="panel-body">
          <div class="row">

              <!-- Select Group -->
              <div class="col-md-4">
                  <div class="form-group" v-if="userIsGroupAdmin">
                      <h4>
                        Welcome, {{ authUser.FirstName }}
                      </h4>
                      <p>
                        You are viewing stats for <strong><i>{{ groupName }}</i></strong>.
                      </p>
                  </div>
                  <div class="form-group" v-if="authUser.AccountType == 2">
                      <label>Groups</label>
                      <div class="select">
                          <select id="groups" class="form-control" v-model="selectedGroup" @change="selectGroup()">
                              <option v-for="(group) in groups" :value="group" :key="group.GroupId">{{ group.GroupName }}</option>
                          </select>
                      </div>
                  </div>
              </div>

              <!-- Select Courses -->
              <div class="col-md-4">
                  <label>Courses</label>

                  <ul class="list-group group-courses">

                    <li class="form-check list-group-item" v-for="(groupCourse) in groupCourses" :key="groupCourse.GroupCourseMasterId" v-if="groupCourses.length > 0">

                        <input class="form-check-input" :id="groupCourse.GroupCourseMasterId" type="checkbox" v-model="selectedCourses" :value="groupCourse" @change="selectGroupCourse()">
                        <label class="form-check-label">
                          {{ groupCourse.CourseTitle | excerpt(40) }} - <small class="red">{{ groupCourse.CourseSubTitle | excerpt }}</small>
                        </label>

                    </li>

                    <div v-if="groupCourses.length === 0">
                      <p class="red">
                          <strong>No Courses available for the selected Group</strong>
                      </p>
                    </div>
                  </ul>
              </div>


              <!-- Select Cohorts -->
              <div class="col-md-4">
                  <label>Cohorts</label>
                  <div v-if="selectedCourses.length > 0" class="group-courses-cohorts">
                      <div v-for="groupCoursesCohorts in groupCohorts" :key="groupCoursesCohorts.GroupCourseMasterId">

                          <ul class="list-group">
                            <li class="list-group-item list-group-header disabled" v-once>{{ groupCoursesCohorts.CourseMasterTitle | excerpt(45) }}</li>
                            <li class="form-check list-group-item" v-for="groupCohort in groupCoursesCohorts.CohortList" :key="groupCohort.CohortId">
                                <input class="form-check-input" :id="groupCohort.CohortId" type="checkbox" v-model="selectedCohorts" :value="groupCohort" @change="selectGroupCourseCohort(groupCohort)">
                                <label class="form-check-label">
                                    {{ groupCohort.CohortName }}
                                </label>
                            </li>
                          </ul>

                      </div>
                  </div>
                  <div class="form-group" v-if="!groupCohorts.length">
                      <p class="red" v-if="!selectedCourses.length">
                          <strong>Please select at least 1 Course</strong>
                      </p>
                      <p class="red" v-else>
                          <strong>No Cohorts available for selected GroupCourses</strong>
                      </p>
                  </div>

              </div>
          </div>
        </div>

    </div>
</template>

<script>
import 'bootstrap'

export default {
  data () {
    return {
      selectedGroup: this.$store.getters.selectedGroup,
      selectedCohorts: [],
      selectedCourses: []
    }
  },

  computed: {
    uniqId () {
      // eslint-disable-next-line
      return _.uniqueId()
    },
    groups () {
      return this.$store.getters.groups
    },

    groupCourses () {
      return this.$store.getters.groupCourses
    },

    groupCohorts () {
      return this.$store.getters.groupCohorts
    },

    authUser () {
      return this.$store.state.curr_user
    },

    userIsAdmin () {
      return this.$store.getters.userIsAdmin
    },

    userIsGroupAdmin () {
      return this.$store.getters.userIsGroupAdmin
    },

    groupName () {
      return this.$store.getters.selectedGroup.GroupName
    }
  },

  methods: {

    selectGroup () {
      // Get GroupCourses for the selected Group
      this.$store.dispatch('fetchAndSetGroupCourses', this.selectedGroup)

      // Reset any previously selected GroupCourses and Cohorts
      this.selectedCourses = this.selectedCohorts = []
      this.eventHub.$emit('groupCourseCohortFilterUpdated')
    },

    selectGroupCourse () {
      this.$forceUpdate()
      if (this.selectedCourses.length > 0) {
        this.$store.commit('setSelectedCohorts', [])
      }
      this.$store.commit('groupCoursesSelected', this.selectedCourses)
      this.$store.dispatch('fetchAndSetGroupCourseCohorts', this.selectedCourses)
      this.$store.dispatch('fetchAndSetGroupCourseStats', this.selectedCourses)
      this.eventHub.$emit('groupCourseCohortFilterUpdated')
    },

    selectGroupCourseCohort () {
      this.$store.commit('setSelectedCohorts', this.selectedCohorts)
      this.eventHub.$emit('groupCourseCohortFilterUpdated')
    }

  }
}
</script>

<style lang="scss">
  .red {
      font-size: 0.8em;
      color: rgba(218, 102, 94, 1.00);
  }

  .red strong {
      color: rgba(218, 102, 94, 1.00);
  }

  #beta-tag {
    opacity: 1;
  }

  li.list-group-item {
    font-size: 0.8em;
  }

  li.list-group-header {
    font-size: 1em;
    font-weight: bold;
    text-align: center;
  }

  .instructions {
    display: inline-block;
  }

  .group-courses,
  .group-courses-cohorts {
    max-height: 300px;
    overflow-y: scroll;
  }

  .group-courses-container {
    max-height: 100px;
    overflow-y: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/GroupCourseCohortFilter.vue